"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSSimChangeComponent = void 0;
const account_service_1 = require("../../services/account.service");
const generic_content_service_1 = require("../../services/generic-content.service");
class CSSimChangeComponent {
    constructor(accountService, genericContentServiceV2) {
        this.accountService = accountService;
        this.genericContentServiceV2 = genericContentServiceV2;
    }
    ngOnInit() {
        this.getGenericContent();
        this.getSimLockStatus();
    }
    getSimLockStatus() {
        this.loader = true;
        this.accountService.getSimChangeAndPortOutLockStatus().subscribe((simLockStatus) => {
            this.loader = false;
            this.hideSection = false;
            if (simLockStatus) {
                this.simLock = simLockStatus.simLock;
                this.portLock = simLockStatus.portLock;
            }
            else {
                this.error = this.genericErrormsgServiceNotAvailable;
                this.hideSection = true;
            }
        }, (err) => {
            this.loader = false;
            this.error = err;
            this.hideSection = true;
        });
    }
    submitSimChangePortLock() {
        this.error = '';
        const simLockPortOutStatus = {
            portLock: this.portLock,
            simLock: this.simLock,
        };
        this.loader = true;
        this.accountService.submitSimChangeAndPortOutLockStatus(simLockPortOutStatus).subscribe(() => {
            this.loader = false;
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
    toggleSimChangeButton() {
        this.simLock = !this.simLock;
        this.submitSimChangePortLock();
    }
    togglePortoutLockButton() {
        this.portLock = !this.portLock;
        this.submitSimChangePortLock();
    }
    getGenericContent() {
        const genericContentIds = [
            'genericSimChangeNotification',
            'genericErrormsgServiceNotAvailable'
        ];
        this.loader = true;
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            this.loader = false;
            for (const genericContent of bulkGenericContent) {
                switch (genericContent.id) {
                    case 'genericSimChangeNotification':
                        this.genericSimChangeNotification = genericContent.content;
                        break;
                    case 'genericErrormsgServiceNotAvailable':
                        this.genericErrormsgServiceNotAvailable = genericContent.content;
                        break;
                    default:
                        break;
                }
            }
        }, (error) => {
            this.loader = false;
            this.error = error;
        });
    }
}
exports.CSSimChangeComponent = CSSimChangeComponent;
//# sourceMappingURL=simchange.component.js.map